export { action, actions, attribute, watcher } from '@engine'
export {
  beginBatch,
  computed,
  effect,
  endBatch,
  filtered,
  getPath,
  mergePatch,
  mergePaths,
  root,
  signal,
  startPeeking,
  stopPeeking,
} from '@engine/signals'

import '@plugins/actions/peek'
import '@plugins/actions/setAll'
import '@plugins/actions/toggleAll'
import '@plugins/actions/fetch'
import '@plugins/attributes/attr'
import '@plugins/attributes/bind'
import '@plugins/attributes/class'
import '@plugins/attributes/computed'
import '@plugins/attributes/effect'
import '@plugins/attributes/indicator'
import '@plugins/attributes/init'
import '@plugins/attributes/jsonSignals'
import '@plugins/attributes/on'
import '@plugins/attributes/onIntersect'
import '@plugins/attributes/onInterval'
import '@plugins/attributes/onSignalPatch'
import '@plugins/attributes/ref'
import '@plugins/attributes/show'
import '@plugins/attributes/signals'
import '@plugins/attributes/style'
import '@plugins/attributes/text'
import '@plugins/watchers/patchElements'
import '@plugins/watchers/patchSignals'
import '@pro/actions/clipboard'
import '@pro/actions/fit'
import '@pro/actions/intl'
import '@pro/attributes/animate'
import '@pro/attributes/customValidity'
import '@pro/attributes/matchMedia'
import '@pro/attributes/onRaf'
import '@pro/attributes/onResize'
import '@pro/attributes/persist'
import '@pro/attributes/queryString'
import '@pro/attributes/replaceUrl'
import '@pro/attributes/scrollIntoView'
import '@pro/attributes/viewTransition'

// Keep Rocket last in the pro bundle. Its runtime queues custom-element
// definitions until Datastar is ready, but the bundle should still expose and
// evaluate Rocket only after the Datastar engine/plugins have been loaded.
export {
  type Codec,
  type CodecDocs,
  type CodecRegistry,
  createCodec,
  publishRocketManifests,
  type RocketDefinition,
  rocket,
} from '@pro/rocket'

const hostname = location.hostname
const allowedHostnames = [
  atob('ZGF0YS1zdGFyLmRldg=='), // 'data-star.dev'
  atob('bG9jYWxob3N0'), // 'localhost'
  atob('MTI3LjAuMC4x'), // '127.0.0.1'
]
if (!allowedHostnames.includes(hostname)) {
  // THIS VERSION OF DATASTAR PRO IS FOR DEMO PURPOSES ONLY!
  alert(
    atob(
      'VEhJUyBWRVJTSU9OIE9GIERBVFNUQVIgUFJPIGlTIEZPUiBERU1PIFBVUlBPU0VTIE9OTFkh',
    ),
  )
}
